import { useEffect } from "react";
import { COMPANY, COPY } from "@/lib/company";

export const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = title ? `${title} | ${COMPANY.name}` : COPY.seoTitle;
    const meta = document.querySelector('meta[name="description"]');
    const prev = meta?.getAttribute("content");
    if (description) meta?.setAttribute("content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.origin + window.location.pathname;
    return () => {
      if (description && prev) meta?.setAttribute("content", prev);
    };
  }, [title, description]);
};

export const dealerJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "AutoDealer",
  name: COMPANY.legalName,
  description: COPY.tagline,
  url: window.location.origin,
  logo: COMPANY.logo ? window.location.origin + COMPANY.logo : undefined,
  telephone: COMPANY.phone,
  email: COMPANY.email,
  foundingDate: COMPANY.since ? String(COMPANY.since) : undefined,
  sameAs: COMPANY.instagram ? [COMPANY.instagram.url] : undefined,
  address: {
    "@type": "PostalAddress",
    streetAddress: COMPANY.street,
    postalCode: COMPANY.city.split(" ")[0],
    addressLocality: COMPANY.city.split(" ").slice(1).join(" "),
    addressCountry: COMPANY.countryCode,
  },
});
